/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React, { Component } from 'react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const styles = (theme) => ({
  input: {
    padding: 0,
  },
});

class CollectionAssetPosition extends Component {
  state = {
    value: this.props.value,
  };
  handleChange = (e) => {
    const value = e.target.value;
    if (!value) return null;
    this.setState(() => ({
      value,
    }));
  };
  handleKeypress = (e) => {
    // if (!e.key.match(/[0-9]/)) e.preventDefault();
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      this.props.onChange(e.target.value);
    }
  };
  render() {
    const { className } = this.props;
    return (
      <TextField
        type="number"
        inputProps={{
          min: 1,
          max: this.props.max,
          className: classNames(className, this.props.classes.input),
        }}
        defaultValue={this.state.value}
        onChange={this.handleChange}
        onKeyPress={this.handleKeypress}
        onBlur={this.handleBlur}
      />
    );
  }
}

export default withStyles(styles)(CollectionAssetPosition);
